import React from 'react';
import { EditIcon } from 'lucide-react';
import EmailTemplateViewer from '@/Components/EmailTemplate/EmailTemplateViewer';
import UIStrings from '@/Utils/UIStrings';
import { getEmailTemplateHtml } from '@/Pages/AccountSettings/utils/getEmailTemplateHtml';
import { Button } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

interface DialogTemplateProps extends React.HTMLAttributes<HTMLDivElement> {
    dialogTitle: string;
    note?: string;
    title: string;
    thankYouMessage: string;
    bodyHtml: string;
    regards: string;
    candidateName: string;
    recruiterName: string;
    companyName: string;
    recruitmentName: string;
    closeDialog: () => void;
    editEmailTemplate: () => void;
    includeRecruiterName: boolean;
}

function DialogTemplate({
    dialogTitle,
    note,
    title,
    thankYouMessage,
    bodyHtml,
    regards,
    candidateName,
    recruiterName,
    companyName,
    recruitmentName,
    closeDialog,
    editEmailTemplate,
    includeRecruiterName,
    className,
    style,
    ...props
}: DialogTemplateProps): React.JSX.Element {
    return (
        <div className={cn('bg-muted flex h-auto w-1/2 grow flex-col gap-3 p-6', className)} style={style} {...props}>
            <div className="mt-12 flex flex-col">
                <div className="flex flex-col gap-3">
                    <h4 className="text-foreground text-xl font-bold">{dialogTitle}</h4>
                    <EmailTemplateViewer
                        htmlTemplate={getEmailTemplateHtml(
                            title,
                            thankYouMessage,
                            bodyHtml,
                            regards,
                            candidateName,
                            recruiterName,
                            companyName,
                            recruitmentName,
                            includeRecruiterName,
                        )}
                        className="bg-background border-border text-foreground h-104 overflow-auto rounded-md border py-2"
                    />
                </div>
            </div>
            {note && (
                <div className="flex flex-col gap-3">
                    <p className="text-foreground text-sm font-normal">{note}</p>
                    <Button size="sm" variant="outline" className="w-44 bg-white" onClick={editEmailTemplate}>
                        {UIStrings.EditEmailTemplate}
                        <EditIcon data-icon="inline-end" />
                    </Button>
                </div>
            )}
        </div>
    );
}

export default DialogTemplate;
